import React, { useState } from 'react';
import { TextInput, StyleSheet, Platform } from 'react-native';
import { useTheme } from '../context/ThemeContext';

const FormInput = ({ style, onFocus, onBlur, onSubmit, returnKeyType, ...props }) => {
    const { palette } = useTheme();
    const [isFocused, setIsFocused] = useState(false);

    const handleFocus = (e) => {
        setIsFocused(true);
        if (onFocus) onFocus(e);
    };

    const handleBlur = (e) => {
        setIsFocused(false);
        if (onBlur) onBlur(e);
    };

    const handleSubmitEditing = () => {
        if (onSubmit) {
            onSubmit();
        }
    };

    return (
        <TextInput 
            style={[
                styles.input, 
                style, 
                { 
                    backgroundColor: 'white', 
                    border: 'none',
                    color: '#000',
                },
                isFocused && Platform.select({
            web: {
                outlineStyle: 'none',
                boxShadow: '5px 7px 0px #18B3B7',
            },
            default: {
                shadowColor: '#000000',
                shadowOffset: { width: 5, height: 7 },
                shadowOpacity: 1,
                shadowRadius: 0,
                elevation: 8,
            },
        }),
            ]} 
            placeholderTextColor={'rgba(0,0,0,0.3)'} 
            onFocus={handleFocus}
            onBlur={handleBlur}
            onSubmitEditing={handleSubmitEditing}
            blurOnSubmit={!onSubmit}
            returnKeyType={returnKeyType || (onSubmit ? "done" : "next")}
            {...props} 
        />
    )
};

const styles = StyleSheet.create({
    input: {
        alignSelf: 'stretch',
        width: '100%',
        height: 52,
        paddingHorizontal: 12,
        paddingVertical: 8,
        borderRadius: 10,
        fontSize: 15,
        fontFamily: 'Chivo',
        fontWeight: '400',
        lineHeight: 20,
                ...Platform.select({
            web: {
                boxShadow: '5px 7px 0px rgba(0,0,0,1)',
            },
            default: {
                shadowColor: '#000000',
                shadowOffset: { width: 5, height: 7 },
                shadowOpacity: 1,
                shadowRadius: 0,
                elevation: 8,
            },
        }),
    },
});

export default FormInput;


